import { Base } from '@studiometa/js-toolkit';

/**
 * @typedef {object} InputFilterDateInterface
 * @property {HTMLInputElement} $el
 */
/**
 * InputFilterDate component
 */
export default class InputFilterDate extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'InputFilterDate',
    emits: ['changing'],
  };

  /**
   * Get the input value
   * @this {InputFilterDate & InputFilterDateInterface}
   * @returns {string}
   */
  get value() {
    return this.$el.value;
  }

  /**
   * mounted
   */
  mounted() {
    this.updateInputValueFromURL(this.$el.id);
  }

  /**
   * onChange send value to parent component
   */
  onChange() {
    this.$emit('changing', this.$el.id, this.value);
  }

  /**
   * getDateInURL
   * @param {string} urlParameter
   */
  updateInputValueFromURL(urlParameter) {
    if (window.location.search === '') {
      return;
    }

    const params = new URLSearchParams(window.location.search);
    const date = params.get(urlParameter);
    this.$el.value = date;
  }
}
